/**
 * Générateur — Il écrit une séquence d'instructions (condition
 * « si … alors » et boucle « répéter … fois »).
 * Attendu ID : 248 | Niveau : 3ème | Domaine : Algorithmique (d21, O2 niv. 2)
 *
 * ⚠️ BANQUE 3e (doc muet — option (a) du TODO §5). Plan auto-validé
 * 2026-07-18 : « compteur » (dérouler une boucle avec un SI : valeur finale
 * de N et du compteur de nombres pairs), « seuil » (que dit le lutin selon
 * la condition Score > s, QCM).
 */

import { randomChoice, randInt, makeQcm, makeTexteTrou } from '../../../utils';
import { imgElement, svgScript } from '../../4eme/algorithmique/algo';

const ATTENDU_ID = 248;
const L_COMPTEUR = 'Dérouler une boucle avec un SI';
const L_SEUIL = 'Si … alors … sinon';
const opts = (label) => ({ niveau: '3eme', matiere: 'maths', attendu: ATTENDU_ID, label });

// ═════════ « compteur » ═════════

const genCompteurTrous = () => {
    let n0; let k; let tours; let nFinal; let compteur;
    for (let essai = 0; essai < 40; essai++) {
        n0 = randInt(2, 9);
        k = randInt(2, 7);
        tours = randInt(3, 5);
        nFinal = n0;
        compteur = 0;
        for (let t = 0; t < tours; t++) {
            nFinal += k;
            if (nFinal % 2 === 0) compteur += 1;
        }
        if (compteur > 0 && nFinal !== compteur) break;
    }
    const phrase = `À la fin : N = {{${nFinal}}} et Compteur = {{${compteur}}}.`;
    const payload = makeTexteTrou(phrase,
        `<p><code>mettre N à ${n0} ; mettre Compteur à 0 ; répéter ${tours} fois [ajouter ${k} à N ; `
        + 'si N est PAIR alors ajouter 1 à Compteur]</code></p>'
        // « Le SI se teste APRÈS chaque ajout » désamorçait l'erreur d'ordre,
        // qui est le point de la carte.
        + '<p><b>Déroule la boucle à la main : que valent N et Compteur à la fin ?</b></p>',
        { ...opts(L_COMPTEUR), mode: 'saisie' });
    payload.elements_additionnels = imgElement(svgScript([
        { t: 'hat', txt: 'quand le drapeau est cliqué' },
        { t: 'variable', txt: `mettre N à ${n0}` },
        { t: 'variable', txt: 'mettre Compteur à 0' },
        { t: 'repeat', n: tours, body: [
            { t: 'variable', txt: `ajouter ${k} à N` },
            { t: 'if', cond: 'N est pair', body: [{ t: 'variable', txt: 'ajouter 1 à Compteur' }] },
        ] },
    ]));
    payload._meta.params = { n0, k, tours, nFinal, compteur };
    return payload;
};

// ═════════ « seuil » — QCM ═════════

const genSeuilQcm = () => {
    const s = randInt(5, 30);
    const ecart = randomChoice([-3, -1, 0, 2, 4]);
    const v = s + ecart;
    const correct = v > s ? '« Gagné ! »' : '« Continue ! »';
    const prenom = randomChoice(['Nour', 'Théo', 'Jade', 'Marius']);
    const payload = makeQcm(['« Gagné ! »', '« Continue ! »', 'Rien : le script plante'], correct,
        `<p>Fin de partie : <code>si Score &gt; ${s} alors dire « Gagné ! » sinon dire « Continue ! »</code>. `
        + `${prenom} termine avec un Score de ${v}.</p>`
        // « la condition est STRICTE » désignait la réponse dans le cas v = s.
        + '<p><b>Que dit le lutin ?</b></p>',
        opts(L_SEUIL));
    payload._meta.params = { s, v, prenom };
    return payload;
};

const GENERATORS = {
    compteur_texte_trou_saisie: genCompteurTrous,
    seuil_qcm_unique: genSeuilQcm,
};
const FORMAT_LABELS = { texte_trou_saisie: 'Saisie trous', qcm_unique: 'QCM' };
const buildFormats = (prefix) =>
    Object.keys(GENERATORS).filter(k => k.startsWith(`${prefix}_`))
        .map(k => ({ key: k, label: FORMAT_LABELS[k.slice(prefix.length + 1)] || k }));
export const CATEGORIES = [
    { id: 'compteur', label: L_COMPTEUR, formatsList: buildFormats('compteur') },
    { id: 'seuil', label: L_SEUIL, formatsList: buildFormats('seuil') },
];
export const generate = (typeExercice) => {
    let key;
    if (typeExercice && GENERATORS[typeExercice]) key = typeExercice;
    else if (typeExercice) {
        const matching = Object.keys(GENERATORS).filter(k => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(Object.keys(GENERATORS));
    } else key = randomChoice(Object.keys(GENERATORS));
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};
